import ev from "../util/enumValue";

enum SlideConditionType {
    PROMOTION_ACTIVE_SPECIFIC = ev('PROMOTION_ACTIVE_SPECIFIC', 1),
    PROMOTION_ACTIVE_ANY = ev('PROMOTION_ACTIVE_ANY', 2)
}

export default SlideConditionType;
